import { render, staticRenderFns } from "./ConfirmedAction.vue?vue&type=template&id=dd73afe0&scoped=true&"
import script from "./ConfirmedAction.vue?vue&type=script&lang=ts&"
export * from "./ConfirmedAction.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmedAction.vue?vue&type=style&index=0&id=dd73afe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd73afe0",
  null
  
)

export default component.exports